/**
 * Export Schedule API Service
 * Handles scheduled CSV export communication with backend
 */

import supabase from '../supabaseClient';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

async function getAuthHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;

  return {
    'Authorization': token ? `Bearer ${token}` : '',
  };
}

/**
 * Get user's export schedule configuration
 */
export async function getExportSchedule() {
  const authHeaders = await getAuthHeaders();
  const response = await fetch(`${API_URL}/api/settings/export-schedule`, {
    headers: authHeaders,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to fetch export schedule');
  }

  return response.json();
}

/**
 * Save (create or update) export schedule
 */
export async function saveExportSchedule(scheduleData) {
  const authHeaders = await getAuthHeaders();
  const response = await fetch(`${API_URL}/api/settings/export-schedule`, {
    method: 'PUT',
    headers: {
      ...authHeaders,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(scheduleData),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to save export schedule');
  }

  return response.json();
}

/**
 * Trigger immediate CSV export to email
 */
export async function exportNow(email) {
  const authHeaders = await getAuthHeaders();
  const response = await fetch(`${API_URL}/api/settings/export-now`, {
    method: 'POST',
    headers: {
      ...authHeaders,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to send export');
  }

  return response.json();
}
